import { LoginCredentials } from '../../api/types';
import { LoginForm } from '../LoginForm';

import { useAuth } from '@/lib/authentication';

type LoginFormProps = {
  onSuccess: () => void;
  onError: (message: string) => void;
};

export const LoginContainer = ({ onSuccess, onError }: LoginFormProps) => {
  const { login, isLoggingIn } = useAuth();

  const handleLogin = async (values: LoginCredentials) => {
    try {
      await login(values);
      onSuccess();
    } catch (err: any) {
      onError(err.response.data.message);
    }
  };

  return <LoginForm login={handleLogin} loginLoading={isLoggingIn} />;
};
